import React from 'react';
import type { KpiViewMode } from './line-item-daily-kpis';
import { KpiCard, KpiValueSkeleton, KpiViewToggle } from './daily-kpis-shared';
import { SeverityHighlightValue } from './delivery-variance-highlight';

export type KpiMetric = { formatted: string; actual: number | null; planned: number | null };

export type PacingDailyKpisProps = {
  viewMode: KpiViewMode;
  setViewMode: (mode: KpiViewMode) => void;
  loading?: boolean;
  unitAbbr: string;
  yesterday: KpiMetric;
  dailyNeeded?: KpiMetric & { label: string };
  avg3Day: string;
  avg7Day: string;
};

export function PacingDailyKpis({
  viewMode,
  setViewMode,
  loading,
  unitAbbr,
  yesterday,
  dailyNeeded,
  avg3Day,
  avg7Day
}: PacingDailyKpisProps) {
  const isSpend = viewMode === 'spend';
  const valueSuffix = isSpend ? undefined : unitAbbr;

  return (
    <div className="border-y border-[#3c4f6a] bg-gradient-to-r from-transparent via-[rgba(60,79,106,0.1)] to-transparent py-6">
      <div className="flex items-center">
        <div className="shrink-0 pr-6">
          <KpiViewToggle viewMode={viewMode} setViewMode={setViewMode} />
        </div>
        <KpiCard
          label="Yesterday"
          value={
            loading ? (
              <KpiValueSkeleton />
            ) : !isSpend && yesterday.actual != null && yesterday.planned != null ? (
              <SeverityHighlightValue
                value={yesterday.formatted}
                actual={yesterday.actual}
                planned={yesterday.planned}
                suffix={valueSuffix}
              />
            ) : (
              <span className="inline-flex items-center gap-1">
                {yesterday.formatted}
                {valueSuffix ? (
                  <span className="text-xs font-normal text-gray-600">{valueSuffix}</span>
                ) : null}
              </span>
            )
          }
        />
        {dailyNeeded ? (
          <KpiCard
            label={dailyNeeded.label}
            value={
              loading ? (
                <KpiValueSkeleton />
              ) : dailyNeeded.actual != null && dailyNeeded.planned != null ? (
                <SeverityHighlightValue
                  value={dailyNeeded.formatted}
                  actual={dailyNeeded.actual}
                  planned={dailyNeeded.planned}
                  suffix="/day"
                />
              ) : (
                dailyNeeded.formatted
              )
            }
          />
        ) : null}
        <KpiCard
          label="3 day avg."
          value={
            loading ? (
              <KpiValueSkeleton />
            ) : (
              <span className="inline-flex items-center gap-1">
                {avg3Day}
                <span className="text-xs font-normal text-gray-600">/day</span>
              </span>
            )
          }
        />
        <KpiCard
          label="7 day avg."
          value={
            loading ? (
              <KpiValueSkeleton />
            ) : (
              <span className="inline-flex items-center gap-1">
                {avg7Day}
                <span className="text-xs font-normal text-gray-600">/day</span>
              </span>
            )
          }
        />
      </div>
    </div>
  );
}
